module.exports = __webpack_public_path__ + "assets/b57.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b57.png
// module id = 646
// module chunks = 0